import React from "react";
import { LogoHorizontal } from "./brand/Logo";
import { BRAND, ABN } from "@/lib/brand";

/**
 * Footer content is factual only.
 *
 * The previous version listed three retired USD tiers (Category Maps, Monthly
 * Monitor, Leak Audit), claimed a Manhattan office, asserted a "Research LLC"
 * entity, described the output as "Deterministic" (an LLM writes the narrative),
 * and printed a stale build string. All of it was removed rather than restyled.
 */
export default function Footer() {
  return (
    <footer className="border-t border-[#c9c3b8] bg-[#dcd7ce]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-[2fr_1fr_1fr] gap-10 md:gap-16">
          <div>
            <div className="mb-5">
              <LogoHorizontal size={30} />
            </div>
            <p className="font-serif-display text-xl text-[#171717] max-w-md leading-snug">
              Commercial intelligence for operators who read the ledger before
              they read the dashboard.
            </p>
            <p className="mt-5 font-mono-tech text-[12px] text-[#525252] max-w-md leading-relaxed">
              Pricing and category management for founder-led Australian DTC brands.
            </p>
          </div>

          <div>
            <div className="tick mb-4">Ladder</div>
            <ul className="space-y-2.5 font-mono-tech text-[12px] text-[#525252]">
              <li><a href="/#intake" className="hover:text-[#171717] hover:underline underline-offset-4 transition-colors">Margin Risk Sweep</a></li>
              <li><a href="/#pricing" className="hover:text-[#171717] hover:underline underline-offset-4 transition-colors">Margin Audit · A$990 launch (standard A$2,500)</a></li>
              <li><a href="/#pricing" className="hover:text-[#171717] hover:underline underline-offset-4 transition-colors">Monthly Retainer · A$4,500</a></li>
            </ul>
          </div>

          <div>
            <div className="tick mb-4">Method</div>
            <ul className="space-y-2.5 font-mono-tech text-[12px] text-[#525252]">
              <li>Public product feeds only</li>
              <li>No store credentials required</li>
              <li>Every figure measured, or its assumption stated</li>
              <li>Sign in to view your briefing</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#ddd8ce] flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <span className="tick">
            © {new Date().getFullYear()} {BRAND} · ABN {ABN} · Adelaide, South Australia
          </span>
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
            {[
              ["/legal/terms", "Terms"],
              ["/legal/privacy", "Privacy"],
              ["/legal/methodology", "How we collect data"],
              ["/legal/disclaimer", "Disclaimer"],
            ].map(([to, label]) => (
              <a key={to} href={to}
                 className="tick hover:text-[#171717] hover:underline underline-offset-4 transition-colors">
                {label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
